import React, { Fragment, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import { useParams } from "react-router-dom";

import { changeInputFn, removeFromGroupFn, resetDataTable, setFlashMessage, setPageLoader } from "../../../../../store/actions";
import { callApi } from "../../../../../helpers/boda-boda/common-helpers/callApi.helpers";
import { InputButton } from "../../../../../components/boda-boda/Forms";
import { ModalUI } from "../../../../../components/boda-boda/Modal/ModalUI";
import UploadModalBody from "./UploadModalBody";
import { getManifestListAPI, getManifestListDedicatedAPI } from "../../../../../config/boda-boda/apiUrls.config";

const UploadCSVBtn = (props) => {
    const formState = useSelector(state => state.FormData);
    const dispatch = useDispatch();
    const { id } = useParams();

    const onSubmit = () => {
        if (get(formState, "upload_csv_data.data.file", null) === null) {
            dispatch(setFlashMessage({
                status: true,
                message: "Please select a csv file",
                type: "danger"
            }));
        } else {
            dispatch(setPageLoader(true));

            callApi(`${getManifestListAPI.url}/${id}`)
                .headers(true)
                .method("put")
                .body({
                    pickRequestCsvUrl: get(formState, "upload_csv_data.data.url", ""),
                    pickRequestCsvResponseUrl: null,
                })
                .send()
                .then((result) => {
                    // dispatch(resetDataTable(getPackageListAPI.key));
                    if (get(result, '_statue', false) === true) {
                        dispatch(changeInputFn(getManifestListDedicatedAPI.key, "pickRequestCsvUrl", "", get(formState, "upload_csv_data.data.url", "")))
                        dispatch(changeInputFn(getManifestListDedicatedAPI.key, "pickRequestCsvResponseUrl", "", null))
                        dispatch(removeFromGroupFn("upload_csv_data"));
                        props.setModelStatusFn(false);
                        dispatch(setPageLoader(false));
                        dispatch(setFlashMessage({
                            status: true,
                            message: "CSV file has uploaded successfully",
                            type: "success",
                        }));
                    } else {
                        if (get(result, "data.statusCode", "") === 403) {
                            dispatch(setFlashMessage({
                                status: true,
                                message: "Permission denied to access",
                                type: "danger",
                            }));
                        }
                        dispatch(setPageLoader(false));
                    }
                })
                .catch((error) => {
                    dispatch(setPageLoader(false));
                })
        }
    }

    return (
        <InputButton
            btnText={"Upload"}
            elementStyle={"btn btn-primary waves-effect waves-light"}
            onClickBtnFn={() => onSubmit()}
        />
    )
};

const UploadPackageCSV = () => {
    const [isOpen, setOpen] = useState(false);
    const dispatch = useDispatch();

    return (
        <Fragment>
            <InputButton
                btnText={"Upload CSV"}
                elementWrapperStyle={"float-right mb-2 mr-1"}
                startIcon={"mdi mdi-content-save-all-outline"}
                onClickBtnFn={() => setOpen(true)}
            />

            <ModalUI
                isOpen={isOpen}
                modalTitle={"Upload CSV"}
                modalBodyComponent={<UploadModalBody />}
                modalFooterComponent={<UploadCSVBtn
                    setModelStatusFn={(value) => setOpen(value)}
                />}
                showHideToggleFn={() => {
                    setOpen(false);
                    dispatch(removeFromGroupFn("upload_csv_data"));
                }}
            />
        </Fragment>
    )
}

export default UploadPackageCSV;
